import { CartLine, ValidationMessageSeverityLevel } from '@next/core-lib/cart';
import { AbstractDialogData } from '@next/core-lib/dialog';

export interface AppState {}

export enum CartColumns {
  deliveryInformation = 'deliveryInformation',
  deliveryPeriod = 'deliveryPeriod',
  lineId = 'lineId',
  priceResults = 'priceResults',
  productSupplements = 'productSupplements',
  shipToId = 'shipToId',
  siloDistribution = 'siloDistribution',
  skuDescription = 'skuDescription',
  skuExternalProductId = 'skuExternalProductId',
  skuId = 'skuId',
  skuSource = 'skuSource',
  skuTitle = 'skuTitle',
  unitInformation = 'unitInformation',
  weightInformation = 'weightInformation',
  hasRemarksValidationsSilosOrSupplements = 'hasRemarksValidationsSilosOrSupplements',
  hasRemarksOrValidationErrors = 'hasRemarksOrValidationErrors',
  quantity = 'quantity',
  quantityAndUnitInformation = 'quantityAndUnitInformation',
  externalInvoiceIdForReturn = 'externalInvoiceIdForReturn',
  returnDate = 'returnDate',
  remarks = 'remarks',
  blockedForReturn = 'blockedForReturn',
}

export interface CartDialogData extends AbstractDialogData {
  cartIdentifier: number;
  cartLine: CartLine;
}

export interface ConfirmDialogData extends AbstractDialogData {
  text?: string;
}

export interface ValidationFeedback {
  message: string;
  errorCode?: string;
  severityLevel: ValidationMessageSeverityLevel;
}
